import React from 'react';
import { styled } from '@mui/material/styles';
import { Paper, Box, Grid, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ChanceStatusIcon from './ChanceStatusIcon';
import { getNumberComma } from '../../../utils/numberUtils';

const WhiteIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.background.paper,
  '&:hover': {
    backgroundColor: theme.palette.getContrastText(
      theme.palette.background.paper,
    ),
  },
}));

const WhiteTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.background.paper,
}));

const ChanceInfo = ({ chance, handleGoBack }) => {
  return (
    <Paper
      sx={{
        mx: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          backgroundColor: '#424242',
        }}
      >
        <Box sx={{ p: 1 }}>
          <WhiteIconButton size="small" onClick={handleGoBack}>
            <ArrowBackIcon aria-label="goBack" />
          </WhiteIconButton>
        </Box>
        <Box
          sx={{
            py: 1,
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <ChanceStatusIcon chance={chance} />
          <Box sx={{ ml: 2 }}>
            <WhiteTypography variant="subtitle2" component="div">
              현재 단계: {chance?.cstStatus}
            </WhiteTypography>
            <WhiteTypography variant="subtitle1" component="div">
              {chance.cstNm}
              <Typography component="span" variant="caption" sx={{ ml: 1, opacity: 0.7 }}>
              {chance?.prjNo}
            </Typography>
            <Typography component="span" variant="caption" sx={{ ml: 1, opacity: 0.7 }}>
              {chance?.customerNm}
            </Typography>
            </WhiteTypography>
            
          </Box>
        </Box>
      </Box>
      {/* <Box sx={{ px: 2, py: 2 }}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={3} align="center">
            <Typography variant="subtitle2" component="div">
              프로젝트 번호
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="subtitle2" component="div">
              매출처명
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="subtitle2" component="div">
              매출 예상일
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="subtitle2" component="div">
              예상 금액
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={3} align="center">
            <Typography variant="body2" component="div">
              {chance?.prjNo}
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="body2" component="div">
              {chance?.vendorCmpNm}
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="body2" component="div">
              {chance.expDay ? chance?.expDay : `-`}
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="body2" component="div">
              {getNumberComma(chance.expSales)}
            </Typography>
          </Grid>
        </Grid>
      </Box> */}
    </Paper>
  );
};

export default ChanceInfo;
